const getDisplayName = (toolType) => {
    return toolType
        .split('_')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
};
export const getRenamedColumns = (columns, newColumn, toolType) => {
    let suffix = 0;
    const toolSuffix = getDisplayName(toolType);
    let root = newColumn;
    if (!columns.find((column) => column === newColumn))
        return newColumn;
    const parts = newColumn.split('_');
    if (parts.length > 1) {
        const last = parts[parts.length - 1];
        if (!isNaN(parseInt(last))) {
            suffix = parseInt(last);
            root = newColumn.slice(0, newColumn.length - last.length - 1);
        }
    }
    while (true) {
        suffix = suffix + 1;
        const newName = `${root}_${toolSuffix}_${suffix}`;
        if (!columns.find((column) => column === newName))
            return newName;
    }
};
export const getAllColumnNames = (source) => {
    return source.map((col) => col.name);
};
//# sourceMappingURL=toolConfigUtil.js.map